import { isEmpty } from 'lodash';

import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { StyledSpecialtiesText } from './SpecialtiesText.styled';

type SpecialtiesProps = {
   readonly specialties: string[];
   readonly compact?: boolean;
   readonly secondary?: boolean;
};

export const SpecialtiesText = (props: SpecialtiesProps): JSX.Element => {
   return (
      <StyledSpecialtiesText testId={'specialties'} $compact={props.compact} $secondary={props.secondary}>
         {isEmpty(props.specialties) ? (
            <Translate>{translationKeys.noSpecialties}</Translate>
         ) : (
            props.specialties.join(', ')
         )}
      </StyledSpecialtiesText>
   );
};
